import React from 'react';

const Loader = ({isLoading, loaded}) => {
    return (
        <div className={`page_loader ${isLoading ? 'loading' : ''} ${loaded ? 'loaded' : ''}`}>
            <div className="page_loader_content">
                <img width={900} height={209} src={'/white_logo.svg'} alt={'HFDX logo'}/>
            </div>
        </div>
    );
};

export default Loader;